import { Icon } from '@circlek-global/lds-components';

/**
 * Maps service/fuel names to their corresponding icons.
 * Organized by region (NA/EU) and category (Services/Fuels/Truck/EV).
 */
export const SERVICE_ICON_MAP: Record<string, Icon> = {
  // NA Services
  NA_ALCOHOL: Icon.PERCENT_02,
  NA_ATM: Icon.ATM,
  NA_BEER: Icon.BEER,
  NA_CARWASH: Icon.DROP,
  NA_CHECK_CASHING_MACHINE: Icon.BANK_NOTE_01,
  NA_COFFEE: Icon.COFFEE,
  NA_DELIVERY: Icon.PACKAGE_CHECK,
  NA_DRIVETHRU: Icon.DRIVETHRU,
  NA_FRESH_FOOD: Icon.SHOPPING_BAG_01,
  NA_FRESHFASTFOOD: Icon.FASTFOOD,
  NA_GIFT_CARD_MALL: Icon.GIFT_02,
  NA_GIFT_CARD: Icon.GIFTCARD_01,
  NA_GIFTCARDS: Icon.GIFTCARD_02,
  NA_LIQUOR: Icon.LIQUOR,
  NA_LOTTERY: Icon.TICKET_01,
  NA_LOYALTYCK: Icon.LOYALTY_CK,
  NA_LOYALTYFUEL: Icon.LOYALTY_FUEL,
  NA_LOYALTYGRORCERY: Icon.SHOPPING_CART_04,
  NA_MOBILE_PAYMENTS_FUEL_BUSINESS: Icon.PHONE_08,
  NA_MONEY_ORDERS: Icon.BANK_NOTE_03,
  NA_PAY_BY_PLATE: Icon.PHONE_08,
  NA_POLARPOP: Icon.POLARPOP,
  NA_PUBLIC_RESTROOMS: Icon.WC,
  NA_ROLLERGRILL: Icon.SAUSAGE,
  NA_WALKUPWINDOW: Icon.WALKUP_WINDOW,
  NA_WINE: Icon.WINE,

  // NA Fuels
  NA_DIESEL: Icon.DISPENSER,
  NA_GAS: Icon.DISPENSER,
  NA_PREMIUM: Icon.DISPENSER,
  NA_UNLEADED: Icon.DISPENSER,

  // NA Truck
  NA_TRUCK_DEF: Icon.TRUCK_01,
  NA_TRUCK_DIESEL: Icon.TRUCK_01,
  NA_TRUCKSTOP: Icon.TRUCK_03,

  // NA EV
  NA_EVCHARGING: Icon.STANDALONE_CHARGER,

  // EU Services
  EU_ACCESSIBLE_FACILITIES: Icon.WHEELCHAIR,
  EU_ATM: Icon.ATM,
  EU_BABY_CHANGING: Icon.BABY_CHANGING,
  EU_BITCOIN_MACHINE: Icon.CURRENCY_BITCOIN_CIRCLE,
  EU_CAR_RENTAL: Icon.TRUCK_01,
  EU_CARWASH_JETWASH: Icon.CARWASH,
  EU_CARWASH_SUBSCRIPTION: Icon.CAR_SUBSCRIPTION,
  EU_CARWASH: Icon.DROP,
  EU_CLICK_AND_COLLECT: Icon.CURSOR_CLICK_02,
  EU_GIFTCARDS: Icon.GIFTCARD_02,
  EU_GROCERY_BAKERY: Icon.BREAD,
  EU_INDOOR_PRODUCTS_MPB2B: Icon.PHONE_05,
  EU_KFREEZE: Icon.SNOWFLAKE_01,
  EU_LOTTO: Icon.TICKET_01,
  EU_LOUNGE: Icon.HOME_SMILE,
  EU_MADE_TO_GO_FAST_FOOD: Icon.FASTFOOD,
  EU_MOBILE_PAYMENTS_CARWASH_BUSINESS: Icon.PHONE_07,
  EU_MOBILE_PAYMENTS_CARWASH: Icon.PHONE_03,
  EU_MOBILE_PAYMENTS_FUEL_BUSINESS: Icon.PHONE_08,
  EU_MOBILE_PAYMENTS_FUEL: Icon.PHONE_04,
  EU_PAY_BY_PLATE_CARWASH: Icon.CREDIT_CARD_01,
  EU_PAY_BY_PLATE: Icon.PHONE_08,
  EU_PIZZA_HUT: Icon.PIZZA,
  EU_POSTAL_SERVICE: Icon.MAIL_01,
  EU_RETURN_MACHINE: Icon.CIRCLE,
  EU_ROAD_TAXES: Icon.BANK_NOTE_01,
  EU_SELF_CHECKOUT: Icon.PHONE_06,
  EU_SERVICE_ZONE: Icon.PUZZLE_PIECE_01,
  EU_SHOWER: Icon.SHOWER,
  EU_SIMPLY_GREAT_COFFEE: Icon.COFFEE,
  EU_SMOOTHIE_JUICE: Icon.DROP,
  EU_TOILETS_BOTH: Icon.WC,
  EU_TRACKERS_CLUB: Icon.TRUCK_06,
  EU_TRAILER_RENTAL: Icon.TRAILER,
  EU_TRUCK_PARKING: Icon.TRUCK_03,
  EU_TRUCKDIESEL_NETWORK: Icon.TRUCK_04,
  EU_VACUUM_CLEANER: Icon.VACUUM_CLEANER,
  EU_WASHING_MACHINE: Icon.WASHING_MACHINE,
  EU_WIFI: Icon.WIFI,
  EU_WINDSHIELD_LIQUID_ON_PUMP: Icon.DROP,

  // EU Fuels
  EU_ADBLUE_SERVICE: Icon.DISPENSER,
  EU_FUEL_PARTNERS: Icon.LOYALTY_FUEL,
  EU_GAS: Icon.DISPENSER,
  EU_HIGH_SPEED_PUMP: Icon.SPEEDOMETER_01,

  // EU EV
  EU_EV_TRUCK_CHARGER: Icon.TRUCK_05,
  EU_HIGH_SPEED_CHARGER: Icon.ZAP,
};
